export const setCookieValue = (key: string, value: string) => {
  document.cookie = `${key}=${value}; path=/;`;
};

export const getCookieValue = (key: string): string | undefined => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${key}=`))
    ?.split("=")[1];
};
